import React from "react";
import { Link, useLocation } from "react-router-dom"; // useNavigate yerine Link eklendi
import { TABS } from "./tabs";
import { useAuth } from "../context/AuthContext";
import gsLogo from "../../assets/gs_logo-goktas.svg";

function SidebarTabs() {
  const location = useLocation();
  const { permissions } = useAuth();

  const filteredTabs = TABS.filter((tab) => {
    if (tab.type === "section") return true;
    if (!tab.perm) return true;
    return permissions.includes(tab.perm);
  });

  const visibleTabs = filteredTabs.filter((tab, idx) => {
    if (tab.type !== "section") return true;

    const nextSectionIndex = filteredTabs.findIndex(
      (t, i) => i > idx && t.type === "section"
    );

    const children = filteredTabs.slice(
      idx + 1,
      nextSectionIndex === -1 ? filteredTabs.length : nextSectionIndex
    );

    const hasChild = children.some(
      (t) => t.type !== "section" && (!t.perm || permissions.includes(t.perm))
    );

    return hasChild;
  });

  return (
    <aside
      style={{
        width: "240px",
        height: "100vh",
        borderRight: "1px solid #ececf1",
        background: "#fff",
        position: "fixed",
        left: 0,
        top: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          padding: "20px",
          borderBottom: "1px solid #ececf1",
          flexShrink: 0,
        }}
      >
        <img
          src={gsLogo}
          alt="Logo"
          style={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            background: "#f1f2f6",
          }}
        />
        <span style={{ fontWeight: 600, fontSize: 18, color: "#283049" }}>
          Göktaş Portal
        </span>
      </div>

      <div
        style={{
          flex: 1,
          overflowY: "auto",
        }}
      >
        {visibleTabs.map((tab) =>
          tab.type === "section" ? (
            <div
              key={tab.label}
              style={{
                padding: "10px 20px 5px",
                fontSize: 12,
                fontWeight: 700,
                color: "#999",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                marginTop: 15,
              }}
            >
              {tab.label}
            </div>
          ) : (
            <Link
              key={tab.key}
              to={tab.route}
              style={{
                display: "block", // Link'in buton gibi tam genislik kaplamasi icin
                textDecoration: "none", // Alt cizgiyi kaldirir
                textAlign: "left",
                background: "none",
                border: "none",
                padding: "10px 20px",
                fontWeight: 500,
                fontSize: 14,
                width: "100%",
                color: location.pathname.startsWith(tab.route)
                  ? "#1976d2"
                  : "#607098",
                backgroundColor: location.pathname.startsWith(tab.route)
                  ? "rgba(25,118,210,0.08)"
                  : "transparent",
                borderLeft: location.pathname.startsWith(tab.route)
                  ? "4px solid #1976d2"
                  : "4px solid transparent",
                cursor: "pointer",
                transition: "all .2s",
              }}
            >
              {tab.label}
            </Link>
          )
        )}
      </div>
    </aside>
  );
}

export default SidebarTabs;
